import { ModalsModule, Statuses, StatusesModule } from '@wix/domains-search-suite';
import { getPremiumEssentials } from '@wix/premium-fed-sdk/@premium-essentials';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { fetchWithFallback } from '@wix/premium-fed-sdk/@apis-infra';
import { EntriFlowStatus, parseDomain } from '@wix/domains-serverless-interface';
const domainTakenModal = ModalsModule.internals.domainsActionsModalsController.domainTakenInWix;
const loaderModal = ModalsModule.internals.domainsSharedModalsController.loaderModal;
const checkAccountLevelEligibility = async rootDomain => {
  const _getPremiumEssentials = getPremiumEssentials(),
    httpClient = _getPremiumEssentials.httpClient;
  loaderModal.show({});
  const _await$Promise$all = await Promise.all([fetchWithFallback(DomainsApiClient.query.domainTakenInAnotherAccountEntriEligibility({
      httpClient: httpClient,
      request: {
        domain: rootDomain
      }
    }), {
      isEligible: false,
      domain: rootDomain
    }), fetchWithFallback(DomainsApiClient.query.canChangeDomainOwner({
      httpClient: httpClient,
      request: {
        domain: rootDomain
      }
    }), {
      canChangeOwner: false
    })]),
    eligibility = _await$Promise$all[0],
    canChangeOwnerRes = _await$Promise$all[1];
  loaderModal.hide();
  return {
    shouldOpenSiteSelector: eligibility.status === 'eligible_to_flow_account_level' || canChangeOwnerRes.status === 'can_change_owner_account_level'
  };
};
export const accountLevelStatusesOverrides = {
  transfer: Statuses.connect,
  domainTakenInWix: _ref => {
    let domainName = _ref.domainName,
      actionHandler = _ref.actionHandler,
      externalViewer = _ref.externalViewer;
    return {
      action: async () => {
        const _await$checkAccountLe = await checkAccountLevelEligibility(domainName ?? ''),
          shouldOpenSiteSelector = _await$checkAccountLe.shouldOpenSiteSelector;
        if (shouldOpenSiteSelector) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            domainName,
            externalViewer
          });
        } else {
          domainTakenModal.show({
            domain: domainName ?? ''
          });
        }
      },
      StatusComponent: StatusesModule.SDK.Components.DomainIsTaken
    };
  },
  subdomainTakenInWix: _ref2 => {
    let domainName = _ref2.domainName,
      actionHandler = _ref2.actionHandler,
      externalViewer = _ref2.externalViewer;
    const rootDomain = parseDomain(domainName ?? '').main;
    return {
      action: async () => {
        const _await$checkAccountLe2 = await checkAccountLevelEligibility(rootDomain),
          shouldOpenSiteSelector = _await$checkAccountLe2.shouldOpenSiteSelector;
        if (shouldOpenSiteSelector) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName
          });
        } else {
          domainTakenModal.show({
            domain: rootDomain
          });
        }
      },
      StatusComponent: StatusesModule.SDK.Components.SubdomainRootIsTaken
    };
  }
};
//# sourceMappingURL=accountLevelStatusesOverrides.js.map